module.exports = __webpack_public_path__ + "assets/img/993af6d1abc4ab7915bb6f76e303d859.svg";